import React from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';

import type { Props as VenmoButtonProps } from '../../../../paypal/components/VenmoButton';
import { VenmoButton } from '../../../../paypal/components/VenmoButton';

export type NewPaymentMethodVenmoProps = VenmoButtonProps;

export function NewPaymentMethodVenmo(props: VenmoButtonProps): React.JSX.Element {
	return (
		<Box as="div" pb={8}>
			<VenmoButton {...props} data-testid="venmo-button" />
		</Box>
	);
}
